import { render, staticRenderFns } from "./StallionDoses.vue?vue&type=template&id=249fc49c&"
import script from "./StallionDoses.vue?vue&type=script&lang=js&"
export * from "./StallionDoses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports